import { Component, OnInit } from '@angular/core';
import { DragAndDropBaseComponent } from '../drag-and-drop-base-component/drag-and-drop-base.component';
import { TranslatorService } from './../../../..//shared/services/utils/translator.service';
import { LeadTypeService } from './../../../../shared/services/leadType/lead.type.service';

@Component({
  selector: 'ngx-lead-type-drag-and-drop',
  templateUrl: './../drag-and-drop-base-component/drag-and-drop-base.component.html',
  styleUrls: ['./../drag-and-drop-base-component/drag-and-drop-base.component.scss']
})
export class LeadTypeDragAndDropComponent extends DragAndDropBaseComponent implements OnInit {

  constructor(
    private readonly leadTypeService: LeadTypeService,
    protected readonly translatorService: TranslatorService,
  ) {
    super(translatorService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.leadTypeService.leadTypeQuery$().subscribe(res => {
      this.itemsList = res.leadTypeList.map(leadType => new Object({
        id: leadType.name,
        name: this.translatorService.trans(`pages.leads.type.${leadType.name}`)
      }));

      this.itemsList = this.itemsList.filter((item) => {
        return item.id !== '';
      });
    });
  }
}
